<template>
  <div class="ex_dianpu_page">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <searchBar @search="openSearch = true" :placeholder="placeholder" :theme="1"></searchBar>
    <div style="padding-top: 0.93rem">
      <banner></banner>
      <notice v-if="exhibitionConfig && exhibitionConfig.display.showExhibitorCount" :num="exList ? exList.totalCount : 0"></notice>
      <navTab style="margin-top: 15px"></navTab>
      <exSwiper :data="Topzxlist" v-if="Topzxlist.length"></exSwiper>
      <van-sticky offset-top="46.5">
        <div class="ex_type" v-if="navList.length" style="background: #fff">
          <van-tabs color="#1890ff" :ellipsis="false" @click="changeHandle">
            <van-tab :title="item.nameEn" :name="index" v-for="(item, index) in navList" :key="item.id"></van-tab>
          </van-tabs>
          <div class="type_nav">
            <van-button class="all_btn" @click="allClick(true)" :class="allActive ? 'is_active' : ''">All</van-button>
            <van-button
              class="dropdownbtn addr"
              :disabled="activeKey == 0"
              @click="classClick"
              :class="{
                is_active: isClassAll || classVals.length > 0,
                xiala: classShow,
              }"
              >{{ isClassAll ? "All" : classVals.length > 0 ? classVals.length : "" }} Category</van-button
            >
            <van-button
              class="dropdownbtn addr"
              @click="areaClick"
              :class="{
                is_active: (!allActive && areaVals.length > 0) || getAllActiveState(),
                xiala: areaShow,
              }"
              >Region</van-button
            >

            <div class="pop_mask" v-if="classShow" @click="classShow = false"></div>
            <div class="pop_mask" v-if="areaShow" @click="areaShow = false"></div>
            <div class="pop_block" v-show="isPopShow">
              <van-popup v-model="classShow" @open="isPopShow = true" @close="isPopShow = false" duration="0" position="top" class="drop_pop" overlay-class="pop_overlay" :get-container="getDomPop">
                <div class="class_con">
                  <div class="class_item" :class="{ is_active: isClassAll }" @click="classAllClick">
                    All
                  </div>
                  <van-checkbox-group v-model="classVals">
                    <van-checkbox class="class_item" v-for="(item, index) in classOption" @click="classChange()" :key="index" :name="item.id">{{ item.nameEn }}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </van-popup>

              <van-popup v-model="areaShow" @open="isPopShow = true" @close="isPopShow = false" duration="0" position="top" class="drop_pop" overlay-class="pop_overlay" :get-container="getDomPop">
                <van-checkbox-group v-model="areaVals">
                  <div class="area_con" v-for="(item, index) in areaOption" :key="index">
                    <p>{{ item.nameEn }}</p>
                    <div class="area_item_warp">
                      <div class="area_item" :class="{ is_active: isAreaAll[index] }" @click="areaAllClick(index)">
                        All
                      </div>
                      <van-checkbox class="area_item" v-for="(mode, ind) in item.lists" @click="areaItemClick(index)" :key="ind" :name="mode.id">{{ mode.nameEn || mode.name }}</van-checkbox>
                    </div>
                  </div>
                </van-checkbox-group>
              </van-popup>
            </div>
          </div>
        </div>
      </van-sticky>
    </div>

    <!-- 展商列表 -->
    <div class="ex_conn">
      <div v-if="dataList.length">
        <van-list v-model="loading" :finished="finished" @load="loadMore">
          <div class="zs" v-for="(item, index) in dataList" :key="index">
            <div class="zs-row s-left">
              <div
                class="zs-row-box-top"
                @click="
                  LinkExInvitation({
                    companyId: item.compId,
                    exhibitorId: item.id,
                    exhibitionId: item.exhibitionId,
                  })
                "
              >
                <div class="zs-item">
                  <div class="zs-logo">
                    <img :class="{ square_logo: configLogoIsSquare }" v-if="item.company.logo" :src="item.company.logo" v-load="'oPic'" />
                    <img
                      :class="{ square_logo: configLogoIsSquare }"
                      v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo"
                      :src="exhibitionInfo.exhibition.logo"
                      v-load="'oPic'"
                    />
                    <img :class="{ square_logo: configLogoIsSquare }" v-else src="@/assets/img/empty.png" />
                  </div>

                  <!-- 公司信息 -->
                  <div class="zs-test">
                    <div class="zs-test-title">
                      <p>{{ item.company.nameEn }}</p>
                      <div class="is_live" v-if="item.isLiving">
                        <span></span>
                        Live
                      </div>
                      <!-- <div class="is_live is_hot" v-if="item.isPopularize">
                      <i class="icon iconfont icon-huo"></i>
                      热榜
                    </div> -->
                    </div>

                    <div class="zs-test-rank" v-if="item.continuouNumber">
                      <div class="type">
                        <div class="img">
                          <img src="@/assets/img/icon/icon-gold.png" v-if="item.continuouNumber > 7" />
                          <img src="@/assets/img/icon/icon-copper.png" v-else-if="item.continuouNumber < 5" />
                          <img src="@/assets/img/icon/icon-silver.png" v-else />
                        </div>
                        <span>Participated in {{ item.continuouNumber }} consecutive exhibitions</span>
                      </div>
                    </div>
                    <!-- 公司下的小标签><-->
                    <div class="zs-test-booth" v-if="item.boothInfo || item.categoryEn">
                      <div class="zs-tag zs-booth" v-if="item.boothInfo">
                        <i class="iconfont icon-dizhi"></i>
                        <p>{{ item.boothInfo }}</p>
                      </div>
                      <div class="zs-tag zs-type" v-if="item.categoryEn">
                        <i class="iconfont icon-biaoqian1"></i>
                        <p>{{ item.categoryEn }}</p>
                      </div>
                      <!-- <div class="zs-tag zs-type" v-else-if="item.category">
                      <i class="iconfont icon-biaoqian1"></i><p>{{item.category}}</p>
                    </div> -->
                    </div>
                    <!-- 数据 -->
                    <div class="zs-test-count">
                      <p>
                        <span
                          ><i>{{ item.productNumber }}</i
                          >Product(s)</span
                        >
                        <span
                          ><i>{{ item.activityNumber }}</i
                          >Activity(s)</span
                        >
                        <!-- <span
                          ><i>{{ item.liveCount }}</i
                          >Live(s)</span
                        > -->
                      </p>
                    </div>

                    <div class="zs-item-bottom">
                      <swiperCard :products="item.products" v-if="item.products.length"></swiperCard>
                      <!-- <p class="zs-item-news" v-if="item.newestEvaluates[0]"><span>最新评价：</span>{{item.newestEvaluates[0].content}}</p> -->
                      <!-- <div
                        class="zs-item-zan"
                        v-if="item.likes && item.likes.length"
                      >
                        <template v-for="(item, index) in item.likes">
                          <img
                            class="img"
                            :src="JSON.parse(item.userInfo).avatarUrl"
                            
                            v-if="JSON.parse(item.userInfo).avatarUrl"
                            :key="index"
                          />
                          <span
                            class="flag-icon img"
                            v-else-if="JSON.parse(item.userInfo).flagStyle"
                            :class="
                              'flag-icon-' + JSON.parse(item.userInfo).flagStyle
                            "
                            :key="index"
                          ></span>
                          <img
                            class="img"
                            src="@/assets/img/empty.png"
                            
                            v-else
                            :key="index"
                          />
                        </template>
                        <p>{{ item.likeCount }} like(s)</p>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            Loading...
          </div>
          <div slot="finished" class="f-tac loading">
            {{ enabledExhibitorLimitNumber ? "Some exhibitors have been hidden" : "It's the end~" }}
          </div> -->
          <div slot="loading" class="f-tac loading"></div>
        </van-list>
      </div>
      <!-- <div class="f-tac" style="line-height: 80px" v-else>No data</div> -->
      <div class="f-tac loading" v-if="loading">
        <img src="@assets/img/new/icon-loading.png" />
        Loading...
      </div>
      <div class="f-tac loading" v-else-if="finished && dataList.length">
        {{ enabledExhibitorLimitNumber ? "Some exhibitors have been hidden" : "It's the end~" }}
      </div>
      <div class="f-tac" style="line-height: 80px" v-else-if="!dataList.length">It's the end~</div>
    </div>
    <!-- 底部导航栏 -->
    <layoutFooter></layoutFooter>
    <!-- 索取样品 -->
    <inquiry ref="inquiry"></inquiry>
    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>
    <!-- 侧边栏 -->
    <exTool :isZT="false" :isZX="false"></exTool>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import layoutFooter from "@components/layout-footer";
import banner from "./component/banner";
import notice from "./component/notice";
import exSwiper from "./component/ex-swiper";
import regionData from "@/assets/js/region.json"; //地区json
import searchBar from "@/components/searchBar/index"; // 搜索切换
import searchPage from "@/components/searchPage"; // 搜索页
import inquiry from "@/components/inquiry/index"; // 搜索切换
import exTool from "../home/components/ex-tool";
import swiperCard from "./component/swiper-card";
import navTab from "../home/components/navTab";
import gql from "graphql-tag";

export default {
  name: "exdianpu-page",
  data() {
    return {
      bannerIndex: 0, //bannerIndex
      activeKey: 0, //一级类别
      areaVals: [], //地区value
      allActive: true, //全部选择 默认全部:all   全部状态下，
      classShow: false, //类别选择弹出框
      areaShow: false, //地区选择弹出框
      isPopShow: false, //弹出层是否显示 ：控制z-index 动画效果需要
      isClassAll: false, //类别选择是否全选
      isAreaAll: [false, false, false], //地区index 0全选(国际)地区index 1全选(中国大陆)地区index 2全选(港澳台)
      //类别数组
      classOption: [],
      //地区数组
      areaOption: [],
      bannerList: [],

      navList: [], // 一级类别
      classVals: [], //类别value
      exList: null, // 展商数据（所有）
      dataList: [], //展商列表数据数组
      loading: true, //展商加载状态
      finished: false, //展商加载是否完成状态
      pageIndex: 1,
      pageSize: 10,
      queryExhibitor: {},
      Topzxlist: [], // 推荐的展商数据
      options: {
        categories: [],
        regions: "",
        country: "",
        province: "",
        city: "",
        county: "",
        compName: "",
        boothInfo: "",
        boothHall: "",
        text: "",
      },
      active: "",
      docTitle: "Exhibitor",
      // 搜索
      openSearch: false, // 控制搜索组件
      rankingType: "CompInfo", // 默认显示展商
      placeholder: "Exhibitors",
      searchType: 0, // 搜索类型
      shareV: {
        content: "",
        poster: "",
      },
    };
  },
  components: {
    layoutFooter,
    banner,
    notice,
    exSwiper,
    searchBar,
    inquiry,
    searchPage,
    exTool,
    navTab,
    swiperCard,
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId",
      hostInfo: "getHostInfo",
      category: "getCategory",
      exhibitionInfo: "getExhibitionInfo",
      search: "getSearch",
      configLogoIsSquare: "getConfigLogoIsSquare",
      exhibitionConfig: "getExhibitionConfig",
      exhibitorsLoadProductNumber: "getExhibitorsLoadProductNumber",
    }),
    enabledExhibitorLimitNumber() {
      // 是否开启展商显示数据的限制
      return this.exhibitionConfig ? this.exhibitionConfig.display.enabledExhibitorLimitNumber : false;
    },
    exhibitorLimitNumber() {
      //展商显示数据的限制多少条
      return this.exhibitionConfig ? this.exhibitionConfig.display.exhibitorLimitNumber : false;
    },
    ZxListGql() {
      return gql`
        query queryExhibitor($query: QueryExhibitorInput!) {
          queryExhibitor(query: $query) {
            hasNextPage
            hasPreviousPage
            pageIndex
            items {
              activities(num: 3) {
                id
                title
              }
              banner
              boothArea
              boothInfo
              businesses(num: 3) {
                id
                remark
                isSample
              }
              category
              categoryEn
              company {
                id
                logo
                name
                category
                region
                regionEn
                address
                nameEn
              }
              compId
              exhibitionId
              followCount
              id
              isPopularize
              isLiving
              likeCount
              lookCount
              productNumber
              activityNumber
              liveCount
              continuouNumber
              likes {
                userInfo
              }
              newestEvaluates {
                id
                content
              }
              products(num: ${this.exhibitorsLoadProductNumber}) {
                id
                exhibitorId
                banner
                view3DUrl
                panoramaUrl
                video
              }
              shareCount
              talkCount
              thinkCount
              userCount
              viewCount
            }
            pageSize
            totalCount
            totalPages
          }
        }
      `;
    },
    region() {
      return this.$route.query.region || false;
    },
  },
  watch: {
    search: function() {
      const txt = this.search.trim();
      console.log(txt, "搜索数据的变化----------");
      if (txt) {
        if (this.searchType == 0) {
          // 按展馆
          this.options = {
            // 输入框
            text: `${txt}`,
          };
        }
        if (this.searchType == 1) {
          // 按展馆
          this.options = {
            // boothInfo: `${txt}`,
            boothHall: `${txt}`,
          };
        }
        if (this.searchType == 2) {
          // 按类别
          this.options = {
            categories: [`${txt}`],
          };
        }
      } else {
        this.options = {
          categories: [],
          regions: "",
          country: "",
          province: "",
          city: "",
          county: "",
          compName: "",
          // boothInfo:'',
          boothHall: "",
          text: "",
        };
      }
      console.log(this.options, "搜索的结果12312");
      this.finished = false; //关闭加载结束
      this.pageIndex = 1;
      this.dataList = [];
      this.getZxList();
    },
  },
  created() {
    this.init();
    this.areaOption = this.getRegionList(regionData);
  },
  methods: {
    ...mapActions({
      LinkExhibitionDetailsOnEx: "linkTo/LinkExhibitionDetailsOnEx",
      LinkProduct: "linkTo/LinkProduct",
      LinkExInvitation: "linkTo/LinkExInvitation",
      shareToWechat: "wxShare/shareToWechat",
      getShareConfig: "wxShare/getShareConfig", //分享配置
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
    }),
    setSearch(e) {
      // 设置搜索值
      console.log(e, "设置搜索值");
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type; // 0为输入搜索，1为展馆，2为类别
      // if(this.searchText){
      //   this.$router.push(`/home/${this.exhibitionId}?search=${this.searchText}&searchType=${this.searchType}`)
      // }
    },
    //打开询盘 点击索取样品
    openInquiry(item) {
      this.$store.commit("company/setExhibitorId", item.id);
      this.$store.commit("company/setCompanyId", item.compId);
      let exInfo = {
        compLogo: item.company.logo,
        compName: item.company.name,
        boothInfo: item.boothInfo,
      };
      this.$refs.inquiry.open(exInfo);
    },
    getCate(arr) {
      let str = "";
      if (arr && arr[0]) {
        for (let i = 0; i < arr.length; i++) {
          str += str ? "," + arr[i].Value : arr[i].Value;
        }
        return str;
      } else {
        return "";
      }
    },
    async init() {
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getCategory(this, this.exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId);
      this.navList = this.sortList(this.category);
      this.navList = this.getList(this.navList);
      this.navList.unshift({ id: "all", name: "All", nameEn: "All" });
      console.log(regionData, "regionData");
      this.getTopZxList();
      if (this.region) {
        this.options.regions = this.region;
        this.serAreaID();
      }
      // this.getZxList();  
      if(this.exhibitionInfo && this.exhibitionInfo.exhibition) {
        this.docTitle = this.exhibitionInfo.exhibition.nameEn || "Exhibitor";
      }

      this.searchText = this.$router.history.current.query.search || "";
      this.searchType = this.$router.history.current.query.searchType || 0;
      if (this.searchText) {
        this.initSearch();
      } else {
        this.getZxList();
      }
      // 分享的配置
      await this.getShareVal();
      const opt = {
        title: this.shareV.content ? this.shareV.content : "诚邀您参观 " + this.exhibitionInfo.exhibition.name + " 线上展",
        desc: this.shareV.des || this.exhibitionInfo.exhibition.remark,
        link: window.location.href,
        imgUrl: this.exhibitionInfo.exhibition.logo,
      };
      this.shareToWechat(opt);
    },
    // 获取展会的分享配置
    async getShareVal() {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.exhibition.config",
      });
      if (res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    // async getShareVal(){
    //   let res = await this.getShareConfig(this.exhibitionId);
    //   if(res&&res){
    //     this.shareV=JSON.parse(res);
    //   }
    // },
    initSearch() {
      const txt = this.search.trim();
      if (txt) {
        if (this.searchType == 0) {
          //  输入框
          this.options = {
            text: `${txt}`,
          };
        }
        if (this.searchType == 1) {
          // 按展馆
          this.options = {
            // boothInfo: `${txt}`,
            boothHall: `${txt}`,
          };
        }
        if (this.searchType == 2) {
          // 按类别
          this.options = {
            categories: [`${txt}`],
          };
        }
      } else {
        this.options = {
          categories: [],
          regions: "",
          country: "",
          province: "",
          city: "",
          county: "",
          compName: "",
          // boothInfo:'',
          boothHall: "",
          text: "",
        };
      }
      console.log(this.options, "路由搜索的结果");
      this.finished = false; //关闭加载结束
      this.pageIndex = 1;
      this.dataList = [];
      this.getZxList();
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex, "当前加载的页面");
      this.getZxList();
    },
    getTopZxList() {
      // 获取推荐的展商列表
      this.$apollo.addSmartQuery("queryExhibitor", {
        query: this.ZxListGql,
        variables: {
          query: {
            exhibitionId: this.exhibitionId,
            page: 1,
            size: 15,
            isTopping: true,
          },
        },
        result(res) {
          let data = JSON.parse(JSON.stringify(res.data));

          if (data && data.queryExhibitor) {
            let currentList = data.queryExhibitor.items;

            currentList.map((c) => {
              // console.log(c,'cccc');
              if (c.category && c.category.indexOf("[") !== -1) {
                if (JSON.parse(c.category)[0]) {
                  c.category = JSON.parse(c.category)[0].Value;
                } else {
                  c.category = "";
                }
              }
              if (c.categoryEn && c.categoryEn.indexOf("[") !== -1) {
                if (JSON.parse(c.categoryEn)[0]) {
                  c.categoryEn = JSON.parse(c.categoryEn)[0].Value;
                } else {
                  c.categoryEn = "";
                }
              }
            });
            if (this.pageIndex == 1) {
              this.Topzxlist = currentList;
            } else {
              this.Topzxlist = [...this.Topzxlist, ...currentList];
            }
          }
        }, // 错误处理
        error(error) {
          console.error(error, "error错误处理");
        },
      });
    },
    getZxList() {
      // 获取展商列表
      this.$apollo.addSmartQuery("queryExhibitor", {
        query: this.ZxListGql,
        variables: {
          query: {
            exhibitionId: this.exhibitionId,
            page: this.pageIndex,
            size: this.pageSize,
            ...this.options,
          },
        },
        fetchPolicy: "network-only", // 清除缓存的数据，重新获取服务器数据
        result(res) {
          console.log("展商res数据", res);
          let data = JSON.parse(JSON.stringify(res.data));
          if (data && data.queryExhibitor) {
            if (this.activeKey == 0) {
              this.exList = data.queryExhibitor;
            }
            let currentList = data.queryExhibitor.items;
            console.log("data", data);

            currentList.map((c) => {
              if (c.category && c.category.indexOf("[") !== -1) {
                if (JSON.parse(c.category)[0]) {
                  c.category = JSON.parse(c.category)[0].Value;
                } else if (JSON.parse(c.category)[1]) {
                  c.category = JSON.parse(c.category)[0].Value + "," + JSON.parse(c.category)[1].Value;
                } else {
                  c.category = "";
                }
              }
              if (c.categoryEn && c.categoryEn.indexOf("[") !== -1) {
                if (JSON.parse(c.categoryEn)[0]) {
                  c.categoryEn = JSON.parse(c.categoryEn)[0].Value;
                } else if (JSON.parse(c.categoryEn)[1]) {
                  c.categoryEn = JSON.parse(c.categoryEn)[0].Value + "," + JSON.parse(c.categoryEn)[1].Value;
                } else {
                  c.categoryEn = "";
                }
              }
            });
            if (this.pageIndex == 1) {
              this.dataList = currentList;
            } else {
              this.dataList = [...this.dataList, ...currentList];
            }
            this.loading = false;
            if (!data.queryExhibitor.hasNextPage) {
              this.finished = true;
            }
            if (this.enabledExhibitorLimitNumber && this.dataList.length >= this.exhibitorLimitNumber) {
              this.finished = true;
              this.dataList = this.dataList.slice(0, this.exhibitorLimitNumber);
            }
            // console.log(this.dataList,'展商列表数据')
          }
        }, // 错误处理
        error(error) {
          console.error(error, "error错误处理");
        },
      });
    },

    sortList (arrJson) {
      console.log('排序前：', arrJson);
      let arr = JSON.parse(JSON.stringify(arrJson));
      arr.sort((a, b) => { return a.showIndex - b.showIndex });
      arr.map((c) => {
        c.type = 1;
        if (c.childrens && c.childrens.length) {
          c.childrens.sort((a, b) => { return a.showIndex - b.showIndex });
        }
        c.children = c.childrens && c.childrens.length ? c.childrens : [];
        if (c.children && c.children.length) {
          c.children.map(e => {
            e.type = c.type + 1;
            if (e.type === 1 || e.type === 2) {
              if (e.childrens && e.childrens.length) {
                e.childrens.sort((a, b) => { return a.showIndex - b.showIndex });
              }
              e.children = e.childrens && e.childrens.length ? e.childrens : [];
            }
          })
        }
      });
      console.log('排序后：', arr);
      return arr;
    },
    // 工具类(遍历类别)
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getList(arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        if (arrJson) {
          arrJson.forEach((el) => {
            const en = el.nameEn || "";
            classArr.push({
              id: el.id,
              name: el.name,
              nameEn: en,
              // name:el.name.length > 4 ? el.name.substring(0, 3) + "..." : el.name,
              // nameEn: en.length > 10 ? en.substring(0, 9) + "..." : en,
              icon: el.icon,
              lists: this.getList(el.childrens, false),
            });
          });
        }
      } else {
        if (arrJson) {
          arrJson.forEach((el) => {
            classArr.push({
              id: el.id,
              name: el.name,
              nameEn: el.nameEn,
              icon: el.icon,
            });
          });
        }
      }
      return classArr;
    },
    // 工具类(遍历地区)
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getRegionList(arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        arrJson.forEach((el) => {
          classArr.push({
            id: el.id,
            name: el.name,
            nameEn: el.nameEn,
            icon: el.icon,
            lists: this.getList(el.lists, false),
          });
        });
      } else {
        arrJson.forEach((el) => {
          classArr.push({
            id: el.id,
            name: el.name,
            nameEn: el.nameEn,
            icon: el.icon,
          });
        });
      }
      return classArr;
    },
    // 返回类别搜索数据(我的)
    getRegionName(arr) {
      let len = arr.length;
      for (let i = len - 1; i >= 0; i--) {
        if (arr[i] != "All") {
          return arr[i];
        }
      }
    },
    getCateName(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
          return arr[i].name;
        }
      }
    },
    serAreaID() {
      let strArr = this.region.split("/");
      let str = strArr[strArr.length - 1];
      // console.log(str,'hah ');
      // console.time("zhengshize");
      for (let i = 0; i < this.areaOption.length; i++) {
        let list = this.areaOption[i].lists;
        for (let j = 0; j < list.length; j++) {
          if (str == list[j].name) {
            this.areaVals.push(list[j].id);
            this.allActive = false;
          }
        }
      }
      // console.timeEnd("zhengshize");
    },
    //获取地区id对应的name和父级name(我的)
    getAreaName(areaId) {
      for (let i = 0; i < this.areaOption.length; i++) {
        let list = this.areaOption[i].lists;
        for (let j = 0; j < list.length; j++) {
          if (areaId == list[j].id) {
            return `${this.areaOption[i].name}/${list[j].name}`;
          }
        }
      }
    },
    getCateGory(arr, splitSign = ",") {
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        let el = arr[i].split("/");
        str += str ? splitSign + el[el.length - 1] : el[el.length - 1];
      }
      return str;
    },
    async getBannerList() {
      this.bannerList = [];
      let res = await this.getBanner("x.page.companies.top");
      this.bannerList = res;
    },

    //数据加载 isLoad 是否list下拉触发的加载(我的)
    async dataLoad(isLoad = false) {
      if (!isLoad) {
        this.dataList = [];
        this.loading = true;   //打开加载状态
        this.finished = false; //关闭加载结束
        this.pageIndex = 1;
      }
      // 初始化数据
      this.finished = false; //关闭加载结束
      this.pageIndex = 1;
      this.dataList = [];
      this.options = {
        categories: [],
        regions: "",
        country: "",
        province: "",
        city: "",
        county: "",
        compName: "",
        boothInfo: "",
        boothHall: "",
        text: "",
      };
      let option = {};
      let leftActive = this.navList[this.activeKey];
      // 按类别搜索
      if (leftActive.id != "all") {
        if (!this.isClassAll && this.classVals.length > 0) {
          let len = this.classVals.length;
          for (let i = 0; i < len; i++) {
            let cateName = this.getCateName(leftActive.lists, this.classVals[i]);
            this.options.categories.push(cateName);
          }
        } else {
          this.options.categories.push(leftActive.name);
        }
      }

      //地区
      let areaIsAll = this.isAreaAll.every((item) => {
        return item;
      });
      if (!areaIsAll) {
        let diqu = [];
        for (let i = 0; i < this.isAreaAll.length; i++) {
          if (this.isAreaAll[i]) {
            diqu.push(this.areaOption[i].name);
          }
        }
        console.log(this.areaVals);
        this.areaVals.forEach((e) => {
          diqu.push(this.getAreaName(e));
        });
        if (diqu.length) {
          option.regions = diqu.join(";");
        }
      }
      this.options.regions = option.regions;
      console.log(this.options, "点击搜索的结果");
      this.getZxList();
    },
    //左侧菜单栏改变 (我的)
    changeHandle(index) {
      this.activeKey = index;
      this.$Myapollo.addExhibitionView();
      if (index) {
        this.classOption = this.getList(this.navList[index].lists, false);
      }
      this.allClick();
      this.$nextTick(() => {
        console.log("选择一级菜单");
        this.dataLoad();
      });
    },
    //左侧菜单栏改变 (我的)
    activeChange(index) {
      this.activeKey = index;
      if (index) {
        this.classOption = this.getList(this.navList[index].lists, false);
      }
      this.allClick();
      this.$nextTick(() => {
        console.log("选择一级菜单");
        this.dataLoad();
      });
    },
    //右侧全部点击 (我的)
    allClick(isdataLoad = false) {
      this.isClassAll = false;
      this.areaVals = [];
      this.classVals = [];
      this.isAreaAll = [false, false, false];
      this.$nextTick(() => {
        this.allActive = true;
      });
      this.areaShow = false;
      this.classShow = false;
      if (isdataLoad) { 
        this.$Myapollo.addExhibitionView();
        this.dataLoad();
      }
    },
    //类别下拉点击
    classClick() {
      this.areaShow = false;
      this.$nextTick(() => {
        this.classShow = !this.classShow;
      });
    },
    //类别全选
    classAllClick() {
      // console.log('类别全选')
      this.isClassAll = !this.isClassAll;
      this.$Myapollo.addExhibitionView();
      this.allActive = false;
      if (this.isClassAll) {
        this.classVals = [];
      }
      this.setAllState();
      this.dataLoad();
    },
    //类别选择点击
    classChange(event) {
      this.$Myapollo.addExhibitionView();
      this.classOption.forEach((ele) => {
        if (this.classVals.includes(ele.id)) {
          ele.isCheck = true;
        } else {
          ele.isCheck = false;
        }
      });
      this.setAllState();
      if (this.classVals.length > 0) {
        this.isClassAll = false;
        this.allActive = false;
      }
      // console.log('类别选择点击')
      this.dataLoad();
    },

    //类别弹出层挂载节点
    getDomPop() {
      return document.querySelector(".pop_block");
    },
    //地区下拉点击
    areaClick() {
      this.classShow = false;
      this.$nextTick(() => {
        this.areaShow = !this.areaShow;
      });
    },
    //地区单个点击  ind:索引 得到是第几个数组里的
    areaItemClick(ind) {
      this.$Myapollo.addExhibitionView();
      this.allActive = false;
      this.$set(this.isAreaAll, ind, false);
      this.$nextTick(() => {
        // console.log('地区单个点击')
        this.dataLoad();
      });
    },
    getAllActiveState() {
      return this.isAreaAll.includes(true);
    },

    //地区全选点击    index:当前全选的索引  0 国际 1中国大陆 2港澳台 （我的）
    // areaAllClick(index) {
    //   this.$set(this.isAreaAll, index, !this.isAreaAll[index]);
    //   if (this.isAreaAll[index]) {
    //     let indexArr = this.getList(this.areaOption[index].lists, false);
    //     let idarr = indexArr.map(el => el.id); //得到当前index下id数组
    //     this.areaVals = this.areaVals.filter(v => !idarr.includes(v)); //干掉地区选择数组里面的index下id数组  过滤
    //   }
    //   this.$nextTick(() => {
    //     // console.log('地区全选点击')
    //     this.dataLoad();
    //   });
    // },

    //改变当前全部状态
    setAllState() {
      if (this.getAllActiveState || this.areaVals.length || this.classVals.length || this.isClassAll) {
        this.allActive = false;
      } else {
        this.allActive = true;
      }
    },
    //处理areaOption数组选中状态
    areaDispose() {
      this.areaOption.forEach((ele) => {
        ele.lists.forEach((mode) => {
          if (this.areaVals.includes(mode.id)) {
            mode.isCheck = true;
          } else {
            mode.isCheck = false;
          }
        });
      });
    },
    //地区全选点击    index:当前全选的索引  0 国际 1中国大陆 2港澳台
    areaAllClick(index) {
      this.$Myapollo.addExhibitionView();
      this.$set(this.isAreaAll, index, !this.isAreaAll[index]);
      if (this.isAreaAll[index]) {
        let indexArr = this.getList(this.areaOption[index].lists, false);
        let idarr = indexArr.map((el) => el.id); //得到当前index下id数组
        this.areaVals = this.areaVals.filter((v) => !idarr.includes(v)); //干掉地区选择数组里面的index下id数组  过滤
        this.areaDispose();
      }
      this.setAllState();
      this.$nextTick(() => {
        // console.log('地区全选点击')
        this.dataLoad();
      });
    },
    swiperChange(e) {
      this.bannerIndex = e.mp.detail.current;
    },
    gotoExOrComp(item) {
      if (item.hasLiveRoom) {
        console.log(item, "看直播");
      } else {
        // console.log(this.userInfo);
        if (this.userInfo.nickName && this.userInfo.avatarUrl) {
          this.LinkCompany(item.compId);
        } else {
          this.authShow = true;
        }
      }
    },
    //banner点击 跳转外连或者展会内其他页面
    goToUrl(url) {
      console.log(url, url.indexOf("pages"));
      if (url.indexOf("pages") == 0) {
        wx.reLaunch({
          url: "/" + url,
        });
      } else {
        this.LinkWebView(url);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ex_dianpu_page {
  min-height: 100vh;
  background: #f2f2f2;
  .ex_title {
    width: 100%;
    height: 2.4rem;
    z-index: 1;
    .banner_swiper {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        // object-fit: cover;
        top: 0;
        left: 0;
        z-index: -1;
      }
    }
  }
  .xiding {
    position: sticky;
    top: 0.64rem;
    z-index: 999;
  }
  .ex_tion_notice {
    display: flex;
    box-sizing: border-box;
    padding: 0 0.24rem;
    height: 0.7rem;
    align-items: center;
    background: #fff;
    color: #666;
    font-size: 0.24rem;
    box-shadow: 0px 3px 5px 0px rgba(171, 170, 170, 0.33);
    p {
      line-height: 0.7rem;
    }
    .iconfont {
      color: #ff5c00;
      transform: scale(1.5);
      margin-right: 0.18rem;
      vertical-align: middle;
    }
    .enter_btn {
      margin-left: auto;
      color: #f85b0f;
      line-height: 0.7rem;
    }
  }
  .ex_tion_banner {
    width: 100%;
    height: 2.4rem;
    padding: 0.3rem 0 0.1rem;
    box-sizing: border-box;
    .swiper-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      overflow: unset;
      .ex_banner_item {
        width: 6.4rem;
        height: 1.8rem;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 0.1rem;
        margin: 0px -0.24rem;
        overflow: hidden;
        position: relative;
        z-index: 1;
        transform: scale(0.79);
        transition: all 0.2s ease-in 0s;
        color: #fff;
        &.on {
          transform: scale(1);
          z-index: 2;
        }
        .item_bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          // object-fit: cover;
          filter: blur(6px);
          z-index: -1;
          transform: scale(1.1);
        }
        .item_mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          z-index: -1;
        }
        .item_top {
          display: flex;
          margin-bottom: 0.15rem;
          img {
            width: 0.78rem;
            height: 0.78rem;
            border-radius: 5px;
            // object-fit: cover;
            margin-right: 0.1rem;
          }
          .top_info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 0.24rem;
            .comp_name {
              line-height: 0.3rem;
              font-size: 0.3rem;
              max-width: 5rem;
            }
            .comp_addr {
              max-width: 2.2rem;
              padding-bottom: 3px;
            }
          }
        }
        .ex_type {
          font-size: 0.2rem;
          max-width: 3.2rem;
          margin-bottom: 0.13rem;
          background: #fff;
        }
        .ex_info {
          display: flex;
          font-size: 0.2rem;
          .icon_jyb {
            width: 0.84rem;
            height: 0.3rem;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fdeddb;
            img {
              width: 0.54rem;
              height: 0.23rem;
              display: block;
            }
          }
          .icon_tag {
            height: 0.3rem;
            padding: 0 4px 0 3px;
            color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            margin-right: 0.1rem;
            &:last-child {
              margin-right: 0;
            }
            &.rz {
              background-color: #ffb528;
            }
            &.qy {
              background-color: #108ee9;
            }
            .iconfont {
              transform: translateY(1px);
            }
          }
        }
        .ex_ban_img {
          display: flex;
          position: absolute;
          bottom: 0.1rem;
          right: 0.1rem;
          justify-content: flex-end;
          div {
            width: 0.94rem;
            height: 0.94rem;
            border-radius: 0.1rem;
            margin-left: 0.06rem;
            overflow: hidden;
          }
          &:first-child {
            margin-left: 0;
          }
          img {
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
      }
    }
  }
  .one_nav {
    width: 100%;
    box-sizing: border-box;
    background: #f2f2f2;
    // padding-left: .24rem;
    color: #666;
    position: relative;
    // z-index: 1900;
    overflow: auto;
    .scroll_view_H {
      white-space: nowrap;
      height: 100%;
      .one_wrap {
        white-space: nowrap;
        height: 100%;
        .one_item {
          padding: 0.4rem 0;
          margin: 0 0.24rem;
          display: inline-block;
          text-align: center;
          font-size: 0.3rem;
          box-sizing: border-box;
          &:last-child {
            margin-right: 0.24rem;
          }
          p {
            position: relative;
            &.is_active {
              color: #ff5c00;
              &::before {
                content: "";
                width: 100%;
                display: block;
                position: absolute;
                left: 50%;
                bottom: -0.1rem;
                transform: translateX(-50%);
                height: 0.04rem;
                background: #ff5c00;
                border-radius: 0.02rem;
              }
            }
          }
        }
      }
    }
  }
  .type_nav {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 0 0.24rem 0.2rem;
    box-sizing: border-box;
    background: #fff;
    .all_btn,
    .dropdownbtn {
      height: 0.54rem;
      width: 2.14rem;
      font-size: 0.24rem;
      border-radius: 0.06rem;
      padding: 0;
      border: none;
      color: #666;
      overflow: hidden;
      line-height: 1;
      position: relative;
      background: #f2f2f2;
      span {
        // width: .7rem;
        display: inline-block;
      }
      &.xiala {
        overflow: initial;
        background: #fff;
        border: 1px solid #0190fe;
        &::before {
          background: #fff;
          border-color: #fff;
        }
        > span {
          color: #0190fe;
          display: inline-block;
          // width: .7rem;
          &::after {
            margin-top: -1px;
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
          }
        }
        &::after {
          content: "";
          position: absolute;
          height: 0.3rem;
          bottom: -0.2rem;
          left: 0;
          right: 0;
        }
      }
      &::after {
        border-color: #1d2435;
      }
      &.is_active {
        color: #1890ff;
        background: rgba(#1890ff, 0.1);
        span {
          // width: 1.2rem;
        }
      }
      &:first-child.is_active {
        // color: #1890ff;
        // background: rgba(#1890ff,0.1);
        background: #1890ff;
        color: #fff;
      }
    }
    &::v-deep .dropdownbtn {
      span {
        padding: 0 0.08rem;
        position: relative;
        left: -0.05rem;
        // width: .7rem;
        &::after {
          position: absolute;
          top: 50%;
          right: -0.1rem;
          margin-top: -5px;
          border: 3px solid;
          border-color: transparent transparent currentColor currentColor;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          opacity: 0.8;
          content: "";
        }
      }
      &.is_active {
        > span {
          color: #0190fe;
          // width: 1.2rem;
        }
      }
    }
    .addr {
      // background: #e6e6e6;
    }
    .all_btn {
      // background: rgba(#1890ff,0.1);
      // color: #1890ff;
      // background: #1890ff;
      // color: #fff;
    }
    .pop_block {
      position: absolute;
      right: 0;
      left: 0;
      top: 0.74rem;
      overflow: hidden;
      z-index: 1002;
      height: 5.2rem;
      &::v-deep .pop_overlay {
        left: 0;
        top: 0;
        position: absolute;
        background-color: transparent;
      }
    }
    .pop_mask {
      z-index: 1000;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      .pop_bg {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 5rem;
        background: rgba(0, 0, 0, 0.4);
      }
    }
    &::v-deep .drop_pop {
      right: 0;
      left: 0;
      top: 0;
      width: auto;
      height: 5.2rem;
      background: #fff;
      padding: 0.2rem 0.25rem;
      position: absolute;
      z-index: 3001 !important;
      .class_con {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        .class_item {
          height: 0.64rem;
          padding: 0 0 0 0.2rem;
          line-height: 0.64rem;
          margin-bottom: 0.12rem;
          border-radius: 0.08rem;
          color: #666;
          background: #f2f2f2;
          &[aria-checked="true"],
          &.is_active {
            background: #d9eeff;
            color: #0190fe;
            .van-checkbox__label {
              color: #0190fe;
              font-size: 0.24rem;
              line-height: initial;
              margin-left: 0;
            }
          }
          .van-checkbox__icon {
            display: none;
          }
          .van-checkbox__label {
            color: #666;
            font-size: 0.24rem;
            line-height: initial;
            margin-left: 0;
            &:after {
              color: #0190fe;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
          &.is-active {
            background: #f85b0f;
          }
        }
      }

      .area_con {
        margin-top: 0.07rem;
        color: #fff;
        &:nth-child(1) {
          margin-top: 0.1rem;
        }
        p {
          color: #666;
          line-height: 1;
          margin-bottom: 0.1rem;
        }
        .area_item_warp {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          &::after {
            content: "";
            width: 30%;
            border: 1px solid transparent;
          }
          .area_item {
            display: block;
            padding: 0 0.13rem;
            margin-bottom: 0.12rem;
            width: 2.2rem;
            height: 0.64rem;
            line-height: 0.64rem;
            text-align: center;
            border-radius: 0.08rem;
            color: #666;
            background: #f2f2f2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &[aria-checked="true"],
            &.is_active {
              background: #d9eeff;
              color: #0190fe;
              .van-checkbox__label {
                color: #0190fe;
              }
            }
            .van-checkbox__icon {
              display: none;
            }
            .van-checkbox__label {
              color: #666;
              font-size: 0.24rem;
              line-height: initial;
              margin-left: 0;
            }
            &.is-active {
              background: #f85b0f;
            }
            .van-checkbox__label {
              color: #666;
            }
          }
        }
      }
    }
  }
}
.ex_conn {
  width: 100%;
  padding-bottom: calc(0.98rem + 0.5rem);
  padding-top: 0.1rem;
  border-top: 1px solid #f4f4f4;
  // min-height:calc(100vh - 5.27rem);
  min-height: 100vh;
  background: #fff;
  .zs {
    width: 100%;
    box-sizing: border-box;
    padding: 0.3rem 0.3rem;
    border-top: 1px solid #f4f4f4;
    &:first-child {
      border-top: none;
    }
    &-item {
      display: flex;
      flex: 1;
      // align-items: center;
      .zs-number {
        color: #333;
        font-weight: bold;
        font-size: 0.28rem;
        flex-shrink: 0;
      }
      .zs-logo {
        // margin-left: .3rem;
        position: relative;
        box-sizing: border-box;
        flex-shrink: 0;
        img {
          width: 0.86rem;
          height: 0.86rem;
          display: block;
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid #eaeaea;
          &.empty-img {
            opacity: 1;
            width: 100%;
            height: auto;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
      .zs-test {
        padding-left: 0.15rem;
        // height: 1.4rem;
        // justify-content: space-between;
        width: calc(100% - 1.2rem);
        &-booth {
          max-width: 95%;
          display: flex;
          align-items: center;
          overflow: hidden;
          height: 0.4rem;
          font-size: 0.2rem;
          color: #666;
          margin-top: 0.08rem;
          margin-left: -0.09rem;
          .zs-addr {
            font-size: 0.2rem;
            flex-shrink: 0;
            margin-right: 0.2rem;
          }
          .zs-tag {
            box-sizing: border-box;
            border-radius: 0.05rem;
            display: flex;
            align-items: center;
            color: #333;
            .iconfont {
              color: #1890ff;
              font-size: 0.42rem;
              transform: translateY(0.03rem);
            }
            .icon-biaoqian1 {
              position: relative;
              top: -0.02rem;
            }
            .icon-dizhi {
              color: #fe781d;
              position: relative;
              top: -0.04rem;
              font-size: 0.38rem;
            }
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .zs-booth {
            margin-right: 0.15rem;
          }
          .zs-type {
            overflow: hidden;
          }
        }
        .item-padd {
          margin: 6px 0 5px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #999;
          flex-wrap: wrap;
          .brand {
            line-height: 1.2;
            margin-right: 8px;
            span {
              color: #999;
              line-height: 18px;
              display: inline-block;
              display: flex;
              align-items: center;
              .icon-zhiboguankanshu {
                position: relative;
                top: -1px;
              }
              .icon-dianzan {
                position: relative;
                top: -2px;
              }
            }
            .iconfont {
              font-size: 18px;
              display: inline-block;
              margin-right: 2px;
              color: #999;
            }
          }
        }
        &-title {
          max-width: 95%;
          display: flex;
          align-items: center;
          p {
            color: #333;
            font-weight: 600;
            font-size: 0.3rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            min-height: 0.34rem;
          }
          .is_live {
            width: 0.88rem;
            height: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            color: #fff;
            margin-left: 0.15rem;
            background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%), linear-gradient(#000, #000);
            background-blend-mode: normal, normal;
            border-radius: 0.05rem;
            color: #fff;
            font-size: 0.18rem;
            // vertical-align: middle;
            span {
              display: block;
              height: 0.12rem;
              width: 0.12rem;
              margin-right: 0.06rem;
              border-radius: 50%;
              background: #fff;
            }
          }
          .is_hot {
            background: #ff5c00;
          }
          .hot_tag {
            width: 0.68rem;
            height: 0.24rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            flex-shrink: 0;
            background-color: #ff5c00;
            border-radius: 0.05rem;
            font-size: 0.14rem;
            margin-left: 0.1rem;
            .iconfont {
              margin-left: -0.06rem;
              font-size: 0.28rem;
              // transform: scale(1.3);
            }
          }
        }
        .english_name {
          max-width: 95%;
          font-size: 0.24rem;
          font-weight: bold;
          line-height: 0.32rem;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &-icon {
          display: flex;
          font-size: 0.2rem;
          position: relative;
          .jyb_text {
            position: absolute;
            left: 0;
            bottom: -0.35rem;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #999;
            font-size: 0.2rem;
            span {
              color: #ff5c00;
            }
          }
          .icon_jyb {
            width: 0.84rem;
            height: 0.3rem;
            border-radius: 0.04rem;
            margin-top: 0.15rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(248, 90, 16, 0.1);
            img {
              width: 0.54rem;
              height: 0.23rem;
              display: block;
            }
          }
          .icon_tag {
            margin-top: 0.1rem;
            height: 0.3rem;
            padding: 0 0.08rem 0 0.05rem;
            color: #fff;
            border-radius: 0.04rem;
            display: flex;
            align-items: center;
            margin-right: 0.1rem;
            &:last-child {
              margin-right: 0;
            }
            &.rz {
              background-color: #ffb528;
            }
            &.qy {
              background-color: #108ee9;
            }
            .iconfont {
              transform: translateY(1px);
            }
          }
        }
        &-rank {
          margin-top: 0.14rem;
          display: flex;
          .type {
            display: flex;
            // width: auto;
            height: 0.42rem;
            background-color: rgba(255, 94, 0, 0.15);
            border: solid 1px #ffe7d9;
            .img {
              width: 0.42rem;
              height: 100%;
              background: #fff;
              img {
                width: 0.3rem;
                height: 0.3rem;
                display: block;
                margin: 0.06rem 0 0 0.06rem;
              }
            }
            span {
              font-size: 0.22rem;
              line-height: 0.42rem;
              color: #ff5e00;
              display: inline-block;
              margin: 0 0.12rem;
              // text-align: center;
              // flex: 1;
            }
          }
        }
        &-count {
          margin-top: 0.08rem;
          p {
            font-size: 0.24rem;
            font-weight: normal;
            line-height: 0.3rem;
            color: #333;
            i {
              font-style: normal;
              color: #fe781d;
              margin-right: 0.08rem;
            }
            span {
              margin: 0 0.1rem;
              &:first-child {
                margin-left: 0;
              }
            }
          }
        }
        .rc-row2 {
          margin-top: 0.04rem;
          color: #666;
          line-height: 0.2rem;
          font-size: 0.12rem;
          color: rgb(102, 102, 102);
          &_item {
            margin-bottom: 0.05rem;
            word-break: break-all;
          }
        }
      }
      &-blist {
        z-index: 2;
        position: relative;
        &_one {
          img {
            width: 100%;
          }
          p {
            font-size: 0.13rem;
            margin-top: 0.06rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      &-bact {
        z-index: 2;
        position: relative;
        .rc-row2_item {
          margin-bottom: 0.1rem;
          font-size: 0.12rem;
          color: #666;
          line-height: 1.5;
          &:only-child,
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      &-act {
        margin-top: 15px;
        .van-notice-bar {
          background: #fff;
          color: #666;
          padding: 0;
          height: 0.46rem;
          .notice-swipe {
            height: 0.46rem;
            width: 100%;
          }
          .act-list {
            line-height: initial;
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              width: 0.48rem;
              height: 0.28rem;
              background-color: #f0eded;
              border-radius: 0.02rem;
              border: solid 1px #d27976;
              color: #e4514c;
              font-size: 0.18rem;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 2px;
              flex-shrink: 0;
              // line-height: .28rem;
            }
            .bus {
              background-color: #ffefe5;
              border: solid 1px #ff5d00;
              color: #ff5e00;
            }
            &-p {
              display: flex;
              align-items: center;
              height: 0.28rem;
              p {
                // max-width: 75%;
                margin-left: 0.08rem;
              }
              &.hd {
                p {
                  // max-width: calc(100% - 0.6rem);
                }
              }
              .no-span {
                max-width: 95%;
              }
              .remark {
                margin-left: 0.08rem;
                font-size: 0.22rem;
                border: none;
                border-bottom: 1px solid #199bff;
                color: #199bff;
                padding: 0;
                background: transparent;
                width: auto;
                height: 0.28rem;
              }
            }
          }
        }
      }
    }
    .zs-row {
      &.s-left {
        padding-left: 0;
      }
      &-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      .zs-img-box {
        position: relative;
        width: 0.6rem;
        height: 0.6rem;
        box-sizing: border-box;
        margin-left: 0.04rem;
        display: inline-block;
        flex-shrink: 0;
        img {
          width: 0.6rem;
          height: 0.6rem;
          display: inline-block;
          border-radius: 50%;
          border: 1px solid #eaeaea;
          &.empty-img {
            opacity: 1;
            width: 100%;
            height: auto;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
    // .zs-item-center {
    //     display: flex;
    //     align-items: center;
    //   .zs-item-bottom-left{
    //     width: 1.4rem;
    //   }
    // .zs-item-bottom{
    //   padding-left: 0.15rem;
    //   width: calc(100% - 1.4rem);
    // }
    .zs-item-blist {
      font-size: 0;
      display: flex;
      position: relative;
      padding: 0.18rem 0.24rem;
      background: #fff;
      box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.2);
      border-radius: 0.06rem;
      &_one {
        width: 31%;
        //  margin-right:20px;
      }
      &_one:nth-child(2n + 2) {
        margin: 0 3.5%;
      }
      &_imgbox {
        width: 100%;
        position: relative;
        height: 0;
        overflow: hidden;
        padding-bottom: 100%;
        .d_tag {
          position: absolute;
          z-index: 1;
          width: 0.6rem;
          height: 0.26rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ff5c00;
          box-sizing: border-box;
          border-radius: 0 0 0 5px;
          color: #fff;
          font-size: 0.16rem;
          right: 0;
          top: 0;
          .iconfont {
            font-size: 0.28rem;
          }
        }
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          // object-fit: cover;
          top: 0;
          left: 0;
        }
      }
    }
    .zs-item-news {
      width: 100%;
      margin-top: 0.2rem;
      background-color: #f7f7f7;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #666;
      padding: 4px 8px;
      span {
        color: #999;
      }
    }
    .zs-item-zan {
      min-width: 100px;
      height: 22px;
      display: flex;
      margin-top: 0.2rem;
      .img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: block;
        border: 1px solid #fff;
      }
      .img:nth-child(1) {
        z-index: 13;
        position: relative;
      }
      .img:nth-child(2) {
        z-index: 12;
        position: relative;
        margin-left: -10px;
      }
      .img:nth-child(3) {
        z-index: 11;
        position: relative;
        margin-left: -10px;
      }
      p {
        min-width: 48px;
        height: 23px;
        color: #999;
        font-size: 0.22rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 18px;
        margin-left: -10px;
        text-align: center;
        padding-right: 5px;
      }
    }
    // }
  }
}
.f-tac {
  text-align: center;
  color: #969799;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
